/*eslint-disable*/
import { request } from '../../utils/request/request'
export function getFirmList(query){
    return request({
        url:'api/fee/v1/Firms',
        method:'get',
        params:query
    })
}
export function getMeterList(query){
    return request({
        url:'api/fee/v1/GetHuBiaoList',
        method:'get',
        params:query
    })
}
